import React from "react";
import { useLocation } from "react-router-dom";

const withNavigationWatcher = (WrappedComponent) => {
  return (props) => {
    const location = useLocation();

    React.useEffect(() => {
      const isMobile = window.innerWidth <= 768;

      if (isMobile) {
        document.body.classList.remove("sidebar-enable", "vertical-collpsed");
      }
    }, [location.pathname]);

    return <WrappedComponent {...props} />;
  };
};

export default withNavigationWatcher;
